<template>
  <div class="huanjing-page">
		<div class="haeder-container blackStatic">
      <Header></Header>
      <Nav></Nav>
    </div>
    <div class="banner huanjing_banner">
			
		</div>		
		<div class="huanjing_body">
			<div class="huanjing1"> 
				<span class="span1">APPLICATION</span>
				<span class="span2">环保大数据</span>
				<span class="span3">禾信质谱大数据云平台</span>
				<img class="img1" src="../../html/image/huanjing/new1.png">
			</div>	
			<div class="huanjing2">
				<span class="span1">设备管理</span>
				<span class="span2">设备状态、污染因子、远程维护</span>
				<img class="img1" src="../../html/image/huanjing/3.png">
			</div>
			<div class="huanjing3">
		    </div>
		    <div class="huanjing4">
		    	<span class="span1">数据采集</span>
				<span class="span2">气象参数、浓度数据、溯源结果</span>
				<img class="img1" src="../../html/image/huanjing/new2.png">
		    </div>
		</div>
		<Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'

export default {
  name: 'huanjing',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {

    }
  },
  mounted() {
  },
}
</script>
<style  scoped>
  @import '../../html/css/zkm.css';
  @import '../../html/css/zkm.market.css';
</style>